// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'



// 获取用户列表
export function getList(data) {
  const url = global.requestUrl + '/user/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建用户信息
export function createOne(data) {
  const url = global.requestUrl + '/user/create'
  return axios.post(url, data)
}

// 更新用户信息
export function updateOne(data) {
  const url = global.requestUrl + '/user/update'
  return axios.post(url, data)
}

// 上传人脸信息
export function createWhiteOne(data, id) {
  const url = global.requestUrl + '/personOrder/face/' + id
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 删除人脸信息
export function deleteWhiteOne(data) {
  const url = global.requestUrl + '/personOrder/delete/' + data.personOrderId
  return axios.get(url)
}

// 绑定企业微信
export function bindOne(data) {
  const url = global.requestUrl + '/user/bindWechat?name=' + data.name
  return axios.get(url)
}

// 删除用户信息
export function deleteOne(data) {
  const url = global.requestUrl + '/user/delete/' + data.id
  return axios.get(url)
}
